import { useEffect, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

/**
 * Wrapper utilitaire : monte ses enfants dans `document.body` via un portail
 * React. À utiliser pour TOUS les modals / drawers / overlays afin d'éviter :
 *
 *  - les marges héritées (`space-y-*` du parent pousse une `position:fixed`
 *    de 16 px vers le bas — bug observé sur la page Bâtiments où le Header
 *    restait visible au-dessus du backdrop) ;
 *  - les stacking contexts créés par un ancêtre avec `transform`, `filter`,
 *    `will-change` (z-index 50 du modal piégé sous z-40 de la sidebar) ;
 *  - les `overflow:hidden` qui rognent visuellement le modal.
 *
 * Le composant retarde le rendu d'un tick côté SSR pour éviter le hydration
 * mismatch (`document` indispo au premier render).
 */
export function ModalPortal({ children }: { children: ReactNode }) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);
  if (!mounted) return null;
  return createPortal(children, document.body);
}
